import { EUserRole } from '@ringana/configs';

// TODO: WEB-3741
// we have a package where the ITokenData is defined (auth-helper) but it only works for backends
// remove it from where and add ITokenData from the auth-helper to the configs package
interface ITokenData {
  cn: number | string;
  exp: number;
  featureName?: string;
  iat: number;
  isAdmin: boolean;
  iss: string;
  name: string;
  role: EUserRole;
  session: string;
}

export default class JWTHelper {
  // function copied from: https://stackoverflow.com/questions/38552003/how-to-decode-jwt-token-in-javascript-without-using-a-library
  public static parseJWT(token: string): ITokenData {
    try {
      const base64Url = token.split(`.`)[1];
      const base64 = base64Url.replace(/-/g, `+`).replace(/_/g, `/`);
      const jsonPayload = decodeURIComponent(atob(base64).split(``).map(c => {
        return `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`;
      }).join(``));

      return JSON.parse(jsonPayload);
    } catch (err) {
      throw new Error(`Failed to parse JWT`);
    }
  }
}
